import { render } from "./DuplicateModal.vue?vue&type=template&id=cd5c8520"
import script from "./DuplicateModal.vue?vue&type=script&lang=ts"
export * from "./DuplicateModal.vue?vue&type=script&lang=ts"
script.render = render

export default script